module.exports = __webpack_public_path__ + "static/media/ville.453112bc.jpg";